@let i18n = translate();
@let control = fg.controls;
@let qrCodeUrl = control['qrCodeUrl'];
@let testIdPrefix = 'rcp-vso-review-qr';

<div class="rcp-grid rcp-grid-cols-1 rcp-gap-1">
    <div class="rcp-mx-auto rcp-mb-2">
        <qrcode
            id="review-qr-code"
            colorLight="#FAFAFA"
            [qrdata]="qrCodeUrl.value"
            [width]="192"
            [elementType]="'img'"
            [errorCorrectionLevel]="'H'"
            [attr.data-testid]="'review-qr-code' | testid: testIdPrefix"
        ></qrcode>
    </div>
    <div class="rcp-mx-auto rcp-mb-6 rcp-inline-flex rcp-items-center rcp-gap-4">
        <button
            mat-flat-button
            class="!rcp-bg-ul-gray-200 !rcp-text-black"
            [attr.data-testid]="'download-qr-code-btn' | testid: testIdPrefix"
            (click)="downloadQrCode()"
        >
            <mat-icon>download</mat-icon> {{ i18n.ACTION__DownloadQrCode }}
        </button>
        <button
            #tooltipBtn="matTooltip"
            matTooltipPosition="above"
            mat-flat-button
            class="!rcp-bg-ul-gray-200 !rcp-text-black"
            matTooltip="{{ isReadOnly() ? i18n.LinkCopied : i18n.ImageCopied }}"
            [matTooltipDisabled]="true"
            [attr.data-testid]="'copy-img-qr-code-btn' | testid: testIdPrefix"
            (click)="isReadOnly() ? copyQrCodeUrl(tooltipBtn) : copyQrCode(tooltipBtn)"
        >
            <mat-icon svgIcon="copy"></mat-icon>
            {{
                isReadOnly() ? i18n.ACTION__CopyQrCodeLink : i18n.ACTION__CopyQrCodeImage
            }}
        </button>
    </div>
</div>
<form
    [formGroup]="fg"
    [attr.data-testid]="'form' | testid: testIdPrefix"
>
    <div class="rcp-grid rcp-grid-cols-1 rcp-gap-6">
        <mat-form-field
            appearance="outline"
            subscriptSizing="dynamic"
        >
            <mat-label [attr.data-testid]="'name-label' | testid: testIdPrefix">{{
                i18n.QrCodeName
            }}</mat-label>
            <input
                matInput
                formControlName="name"
                [attr.data-testid]="'name-input' | testid: testIdPrefix"
            />
        </mat-form-field>
        <mat-form-field
            appearance="outline"
            subscriptSizing="dynamic"
        >
            <mat-label [attr.data-testid]="'email-label' | testid: testIdPrefix">{{
                i18n.CopyQrCodeLink
            }}</mat-label>
            <input
                matInput
                formControlName="qrCodeUrl"
                [readonly]="true"
                [attr.data-testid]="'url-input' | testid: testIdPrefix"
            />
            <div
                matSuffix
                class="!rcp-mr-0.5"
            >
                @if (!isReadOnly()) {
                    <button
                        #tooltipInput="matTooltip"
                        mat-icon-button
                        aria-label="copy"
                        type="button"
                        class="!rcp-bg-ul-gray-100 !rcp-text-black"
                        matTooltipPosition="above"
                        matTooltip="{{ i18n.LinkCopied }}"
                        [attr.data-testid]="'url-input-copy-btn' | testid: testIdPrefix"
                        [matTooltipDisabled]="true"
                        (mouseenter)="$event.stopImmediatePropagation()"
                        (mouseleave)="$event.stopImmediatePropagation()"
                        (click)="copyQrCodeUrl(tooltipInput)"
                    >
                        <mat-icon svgIcon="copy"></mat-icon>
                    </button>
                }
            </div>
        </mat-form-field>
        <mat-form-field
            appearance="outline"
            subscriptSizing="dynamic"
        >
            <mat-label
                [attr.data-testid]="'expirationDate-label' | testid: testIdPrefix"
                >{{ i18n.QrCodeExpirationDate }}</mat-label
            >
            <input
                #input
                matInput
                formControlName="expirationDate"
                [matDatepicker]="picker"
                [min]="minDate"
                [attr.data-testid]="'expirationDate-input' | testid: testIdPrefix"
            />
            <mat-hint class="rcp-uppercase rcp-text-ul-gray-600">{{
                dateFormat()
            }}</mat-hint>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <app-dynamic-actions
            [actions]="actions()"
            [class]="
                'rcp-mt-3 rcp-inline-flex rcp-w-full rcp-items-center rcp-justify-end rcp-gap-4'
            "
        >
        </app-dynamic-actions>
    </div>
</form>
